import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Modal } from 'antd'
import InnerImageZoom from 'react-inner-image-zoom'
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import { getDeliveryValidationsImages, downloadDeliveryValidationsImages } from '../../../flag-management.services'

const Footer = ({ url, responsible }) => {
  const { t } = useTranslation()
  const [downloadLoading, setDownloadLoading] = useState(false)

  const download = async (url) => {
    setDownloadLoading(true)
    const token = localStorage.getItem('token')
    try {
      const response = await downloadDeliveryValidationsImages(url, token)
      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = 'imagen.jpg'
      a.click()
      setDownloadLoading(false)
    } catch (error) {
      setDownloadLoading(false)
    }
  }

  return (
    <div className='photo-viewer footer'>
      <div className='responsable'>
        <b>{t('jobs.job.info.data-validation.photo-viewer.responsible')}: </b>
        <span>{responsible}</span>
      </div>
      <Button
        className='download-button'
        id='download-invoices'
        type='primary'
        loading={downloadLoading}
        onClick={() => download(url)}
      >
        {t('jobs.job.info.data-validation.photo-viewer.download')}
      </Button>
    </div>
  )
}

const PhotoViewerModal = ({ isModalOpen, setModalOpen, title, job, photo, imageType }) => {
  const [photos, setPhotos] = useState([])
  const [selectedPhoto, setSelectedPhoto] = useState('')

  const responsibleName = `${job.tasks[job.tasks.length - 1].resources.firstName} ${
    job.tasks[job.tasks.length - 1].resources.lastName
  }`

  const selectPhoto = (photo, position, images) => {
    const newAlbum = images.map((image, index) => {
      if (position === index) {
        image = {
          ...image,
          class: 'selected'
        }
      } else {
        image = {
          ...image,
          class: ''
        }
      }
      return image
    })
    setPhotos(newAlbum)
    setSelectedPhoto(photo.url)
  }

  useEffect(() => {
    async function getValidationsImages() {
      const images = await getDeliveryValidationsImages(job.id, imageType)
      const photos = images.map((image, index) => {
        return {
          url: image,
          class: index === 0 ? 'selected' : ''
        }
      })
      setPhotos(photos)
      setSelectedPhoto(photos[0].url)
    }
    getValidationsImages()
  }, [])

  return (
    <Modal
      visible={isModalOpen}
      title={title}
      mask={true}
      onCancel={() => setModalOpen(false)}
      maskStyle={{ zIndex: 10001000, background: 'rgba(0,0,0,0.45)' }}
      width={625}
      footer={<Footer url={photo} responsible={responsibleName} />}
      closable={true}
      centered
      bodyStyle={{ display: 'flex', padding: '32px 32px 24px' }}
    >
      <ul className='photo-viewer list'>
        {photos.map((photo, index, arr) => {
          return (
            <li key={index} onClick={() => selectPhoto(photo, index, arr)} className={photo.class}>
              <img src={photo.url} alt='' />
            </li>
          )
        })}
      </ul>
      <figure className='photo-viewer selected-img'>
        <InnerImageZoom src={selectedPhoto} moveType='drag' />
      </figure>
    </Modal>
  )
}

export { PhotoViewerModal }
